import React from 'react';
import './styles.css';

const FilledButton = ({
  content,
  disabled,
  onClick,
  color,
  backgroundColor,
  flat,
  styles,
  className,
}) => (
  <button
    className={`filled-button ${className || ''}${flat ? ' flat' : ''}`}
    disabled={disabled}
    onClick={onClick}
    style={{
      color,
      border: flat ? `solid 1px ${color}` : 'none',
      backgroundColor: disabled ? '#dddddd' : backgroundColor,
      boxShadow: flat ? '' : '0 4px 8px 0 rgba(0, 0, 0, 0.1)',
      ...styles,
    }}
  >
    {content}
  </button>
);

FilledButton.propTypes = {
  content: React.PropTypes.any,
  disabled: React.PropTypes.bool,
  onClick: React.PropTypes.func,
  color: React.PropTypes.string,
  backgroundColor: React.PropTypes.string,
  flat: React.PropTypes.bool,
  styles: React.PropTypes.object,
  className: React.PropTypes.string,
};

export default FilledButton;



// WEBPACK FOOTER //
// ./src/browser/app/components/FilledButton/FilledButton.js